module.exports = __webpack_public_path__ + "images/resume_searches/icon-half-4c336395872b16360ca187096af38c97.svg";